module.exports = __webpack_public_path__ + "static/stalbans-shield-173e66a30fc1df8a2503e5c7c248c30d.png";